import type { ModuleStatus } from 'types/ModuleStatus';
import { PagesActionName } from 'modules/page/pageActions';
import { MODULE_STATUS } from 'constants/modules';
import { PageData, ProfileGroup } from 'types/Page';
import type { ApiClientError } from 'api/client';

export interface PageStore {
  status: ModuleStatus;
  pages: PageData[];
  profileGroups: ProfileGroup[];
  hasLoaded: boolean;
  error: ApiClientError | null;
  isUnauthorized: boolean;
}

function getInitialState(): PageStore {
  return {
    status: MODULE_STATUS.Idle,
    pages: [],
    profileGroups: [],
    hasLoaded: false,
    error: null,
    isUnauthorized: false,
  };
}

function pageReducer(state = getInitialState(), action: any) {
  switch (action.type) {
    case PagesActionName.SET_MODULE_STATUS:
      return {
        ...state,
        status: action.payload,
      };
    case PagesActionName.SET_PAGES_DATA:
      return {
        ...state,
        pages: action.payload.pages,
        profileGroups: action.payload.profileGroups,
        hasLoaded: true,
        error: null,
        isUnauthorized: false,
      };
    case PagesActionName.SET_PAGES_ERROR:
      return {
        ...state,
        error: action.payload.error,
        isUnauthorized: action.payload.isUnauthorized,
      };
    case PagesActionName.SET_PAGE_AUTOSCHEDULE:
      return {
        ...state,
        pages: state.pages.map((page) =>
          page.id === action.payload.pageId
            ? { ...page, isAutoschedule: action.payload.enabled }
            : page,
        ),
      };
    default:
      return state;
  }
}

export default pageReducer;
